import {
    Button,
    FormControl,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import store from '../../../../../core/redux/store';
import { addUserToReportAction } from '../../redux/actions/reports-actions';
import LoadingSpinner from '../loading-spinner';
import { editReportStyles } from './styles';

const emptyUser = {
  id: 'DUMMY_USER',
  firstname: 'Make',
  lastname: 'Selection',
  email: '',
  permissions: {
    permissions_id: '',
    reports: []
  }
};
export default function ReportAddUser() {
  const classes = editReportStyles();
  const dispatch = useDispatch();

  // @ts-ignore
  const { id } = useParams();

  const state = store.getState();
  const token = state.token.token;

  const { report, adding } = useSelector((state) => state.reports);
  const { users, loading } = useSelector((state) => state.users);

  const [selectedUser, setSelectedUser] = useState<string>('DUMMY_USER');

  const submitAddUser = async () => {
    const selectedUserId = selectedUser as string;
    const user = users.find((user) => user.id === selectedUserId);

    if (user) {
      dispatch(
        addUserToReportAction(token, report, [user.permissions.permissions_id], [selectedUserId])
      );
    }
  };

  useEffect(() => {
    if (adding) setSelectedUser('DUMMY_USER');
  }, [adding]);

  const visibleUsers = (users) => {
    return users.filter(
      (user) =>
        !user.permissions?.reports || !user.permissions.reports.some((report) => report.id === id)
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography className={classes.addUsersHeading}>Add user to report</Typography>
        {loading && <LinearProgress />}
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} justify="space-between">
          <Grid item xs={8}>
            <FormControl fullWidth>
              <InputLabel id="user-select-label">Select User</InputLabel>
              <Select
                labelId="user-select-label"
                value={selectedUser}
                label="Select User"
                onChange={(e) => setSelectedUser(e.target.value as string)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300
                    }
                  }
                }}
                style={{
                  color: selectedUser === 'DUMMY_USER' ? 'gray' : 'black',
                  fontStyle: selectedUser === 'DUMMY_USER' ? 'italic' : 'normal'
                }}
              >
                {[emptyUser, ...visibleUsers(users)].map((user) => {
                  const name = `${user.firstname} ${user.lastname}`;
                  return (
                    <MenuItem
                      key={user.id}
                      value={user.id}
                      style={{
                        color: user.id === 'DUMMY_USER' ? 'gray' : 'black',
                        fontStyle: user.id === 'DUMMY_USER' ? 'italic' : 'normal'
                      }}
                    >
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item alignContent="center">
            <Button
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              onClick={() => submitAddUser()}
              disabled={selectedUser === 'DUMMY_USER' || adding}
            >
              {adding && <LoadingSpinner />}
              Add User
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
